import React, {useState} from "react";
import DisposeListType from "./subPages/DisposeListType";
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import useRequestData from "../../../hooks/useRequestData";
import {PageHeader} from "../../../components/PageHeader";
import {getDisposeList} from "../../../api/lifecycle/dispose/DisposeService";

function DisposeList() {

    const [checked, setChecked] = useState([]);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    const {newData, pageInfo, dataHook} = useRequestData(getDisposeList, initDate, "dispose");

    return (
        <>
            <div className="common-container">
                <PageHeader header={"자산폐기관리"} indicator={"라이프사이클 > 자산폐기관리 > 자산폐기관리"}/>
                <DisposeListType
                    data={newData} dataHook={dataHook}
                    date={initDate} pageInfo={pageInfo}
                    checked={{checked: checked, setChecked: setChecked}}/>
            </div>
        </>
    );
}

export {DisposeList};